import Data from 'data';
import { skillAuraStats, skillFormula } from 'logic/skills/calc';
import { AnimationCalculator, whirlwindCalculator } from '../animation';
import { DamageCalculator, missileDamage } from '../damage';
import { DPSCalculator } from '../dps';

const functions = {};

// Double Swing

functions[70] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.convert(skill.etype, skillFormula(skill, 'clc4', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
  animation(skill, stats, level) {
    const anim = new AnimationCalculator(stats, skill);
    if (!anim.type) return;
    anim.baseaccel += skillFormula(skill, 'clc3', stats, level);
    return anim.calculate();
  },
};

// Taunt

functions[71] = {
  buff(id, stats, level) {
    const skill = Data.skills[id];
    return {
      level,
      filter: skill.aurafilter,
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
      targetState: skill.auratargetstate,
      targetStats: () => skillAuraStats(skill, stats, level),
    };
  },
};

// Blessed Hammer

functions[73] = {
  damage(skill, stats, weapon, level, target) {
    const concentration = stats.base.state?.[42];
    const bonus = {};
    if (concentration) {
      bonus.skill_magicdamage = [skillFormula(Data.skills[113], 'ln34', stats, concentration) * skillFormula(skill, 'clc1', stats, level) / 8 | 0, `skill113`];
    }
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target, {stats: bonus});
  },
};

// Double Throw

functions[74] = {
  damage(skill, stats, weapon, level, target) {
    const item = Data.items[weapon.baseitem];
    if (!item?.missiletype) return;
    return missileDamage(Data.missiles[item.missiletype], stats, weapon, 1, target, {
      stats: {
        damagepercent: skillFormula(skill, 'clc1', stats, level),
        tohit_percent: skillFormula(skill, 'toht', stats, level),
      },
    });
  },
};

// Grim Ward

functions[75] = {
  buff(id, stats, level) {
    const skill = Data.skills[id];
    return {
      level,
      filter: skill.aurafilter,
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
      targetState: skill.auratargetstate,
      targetStats: () => skillAuraStats(skill, stats, level),
    };
  },
};

// Whirlwind

functions[76] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
  animation(skill, stats) {
    return whirlwindCalculator(stats, skill).calculate();
  },
  dps(id, stats, level, target, info) {
    if (!info?.damage || !info.animation || (Array.isArray(info.animation) && !info.animation[0])) return;
    const fpa = (Array.isArray(info.animation) ? info.animation[0] : info.animation).fpa;
    const calc = new DPSCalculator();
    calc.basic_damage('damage', info.damage.damage, {fpa, hits: 1});
    if (info.damage.offhand) calc.basic_damage('offhand', info.damage.offhand, {fpa, hits: 1});
    return calc.calculate(stats, target, true);
  },
};

// Leap Attack

functions[78] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.convert(skill.etype, skillFormula(skill, 'clc4', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    return calc.calculate(target);
  },
  animation(skill, stats) {
    const anim = new AnimationCalculator(stats, skill);
    anim.hits = 1;
    return anim.calculate();
  },
};

// Conversion

functions[79] = {
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
};

export default functions;
